import {newAxios} from './index'

export function Req_ChangeExcelToPdf(data){
  // console.log(data)
  return newAxios({
    url:`/i/basic/common/new/excel2pdf`,
    data
  },'json')()
}


// WEBPACK FOOTER //
// ./src/request/excel.js